import { isMobile } from 'react-device-detect';
import useScreenOrientation from '../DeviceOrientation.tsx';

/**
 * Whether this browser will render a generated PDF inline.
 *
 * The preview is an <iframe> pointed at a blob: URL. Mobile browsers - iOS
 * Safari most stubbornly - refuse to render that inline, so those visitors were
 * shown a hidden, useless frame. They get a download link instead; see
 * WorksheetPreview.
 *
 * Portrait counts as "no" on its own because a full US Letter page is unusable
 * at that width even on a browser that would render it.
 */
export function useCanPreviewPdf(): boolean {
    const portrait = useScreenOrientation().toLowerCase().indexOf('portrait') >= 0;
    return !isMobile && !portrait;
}

export default useCanPreviewPdf;
